// extracted by mini-css-extract-plugin
export default {"YearlyAllowanceBarHeaderContainer":"aBqsVIdXPbaZHbXdLXB_"};